import type { HeartbeatRiskKind, HeartbeatRiskStatus } from "./services";

export interface PsychAssistHeartlinePresentation {
  label: string;
  bpmLabel: string;
  color: string;
  durationSeconds: number;
  amplitude: "calm" | "raised" | "urgent";
}

export function resolvePsychAssistHeartline(
  status: HeartbeatRiskStatus | null,
): PsychAssistHeartlinePresentation {
  if (!status) return HEARTLINE_PRESENTATION.insufficient_data;
  const presentation =
    HEARTLINE_PRESENTATION[status.kind] ?? HEARTLINE_PRESENTATION.healthy;
  const bpmLabel = status.latest?.bpm ? `${status.latest.bpm} bpm` : "No Beat";
  return { ...presentation, bpmLabel };
}

const HEARTLINE_PRESENTATION: Record<
  HeartbeatRiskKind,
  PsychAssistHeartlinePresentation
> = {
  insufficient_data: {
    label: "Awaiting Beat",
    bpmLabel: "No Beat",
    color: "var(--fintheon-text)",
    durationSeconds: 60,
    amplitude: "calm",
  },
  healthy: {
    label: "Stable",
    bpmLabel: "Stable",
    color: "var(--fintheon-accent)",
    durationSeconds: 60,
    amplitude: "calm",
  },
  elevated: {
    label: "Elevated",
    bpmLabel: "Elevated",
    color: "#ac5318",
    durationSeconds: 18,
    amplitude: "raised",
  },
  hot_hand_watch: {
    label: "Hot Hand",
    bpmLabel: "Hot Hand",
    color: "#ac5318",
    durationSeconds: 10,
    amplitude: "raised",
  },
  red_pnl_elevated: {
    label: "Pause",
    bpmLabel: "Pause",
    color: "#da0000",
    durationSeconds: 5,
    amplitude: "urgent",
  },
};
